import { makeStyles } from "@saleor/macaw-ui";

const useStyles = makeStyles(
  theme => ({
    root: {
      "& .MuiPaper-root": {
        width: "100%",
        borderRadius: 16,
        position: "relative"
      },
      "& .MuiDialogTitle-root": {
        padding: "20px",
        textAlign: "center"
      },
      "& .MuiDialogContent-root": {
        padding: "24px 24px 0 24px",
        textAlign: "center"
      },
      "& .MuiDialogActions-root": {
        borderTop: 0,
        padding: "24px",
        columnGap: 16,
        justifyContent: "end"
      },
      "& .MuiButton-root": {
        fontSize: "1.8rem",
        "& .MuiTypography-root": {
          fontSize: "1.8rem"
        }
      },
      "& .MuiTypography-h6": {
        width: "100%"
      },
      "& .MuiGrid-root": {
        padding: "2px 8px"
      }
    },
    dialogContent: {
      display: "flex",
      flexDirection: "column",
      gap: 16
    },
    btnAction: {
      height: 48,
      "&.MuiButton-containedPrimary .MuiTypography-root": {
        color: "#ffffff"
      }
    },
    typeButton: {
      height: 48,
      borderColor: "#009FB8",
      "&:hover": {
        borderColor: "#007B9E !important",
        background: "#f6f6f6ff !important"
      },
      "&:active": {
        border: "none",
        outline: "none"
      }
    },
    typeButtonSubmit: {
      background: "#009FB8 !important",
      "&:hover": {
        background: "#007B9E !important"
      }
    },
    dialogTitle: {
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      background: theme.palette.gardient.medium + " !important",
      borderRadius: "16px 16px 0 0",
      width: "100%"
    },
    titleHeader: {
      color: theme.palette.common.white,
      width: "100%",
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      fontSize: "20px !important",
      fontWeight: 400
    },
    closeIcon: {
      cursor: "pointer"
    },
    detailsContainer: {
      display: "flex",
      textAlign: "start",
      "& p": {
        margin: "0 !important"
      }
    },
    required: {
      color: "red"
    },
    inputBlock: {
      display: "flex",
      flexDirection: "column",
      gap: 2,
      marginTop: 16
    },
    btnClose: {
      color: "#009FB8 !important",
      fontSize: "14px !important",
      fontWeight: 700
    },
    btnSubmit: {
      color: theme.palette.common.white,
      fontSize: "14px !important",
      fontWeight: 700
    },
    inputTextField: {
      width: "100%",
      paddingRight: "8px !important"
    },
    width650: {
      "& .MuiDialog-container": {
        alignItems: "center",
        justifyContent: "center"
      },
      "& .MuiPaper-root": {
        maxWidth: 650,
        margin: "auto",
        position: "relative"
      }
    }
  }),
  { name: "DialogEditMaterial" }
);

export default useStyles;
